import { render, staticRenderFns } from "./AudiencesPage.vue?vue&type=template&id=2c02801d&scoped=true"
import script from "./AudiencesPage.vue?vue&type=script&lang=js"
export * from "./AudiencesPage.vue?vue&type=script&lang=js"
import style0 from "./AudiencesPage.vue?vue&type=style&index=0&id=2c02801d&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c02801d",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c02801d')) {
      api.createRecord('2c02801d', component.options)
    } else {
      api.reload('2c02801d', component.options)
    }
    module.hot.accept("./AudiencesPage.vue?vue&type=template&id=2c02801d&scoped=true", function () {
      api.rerender('2c02801d', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/use-metrics/pages/AudiencesPage.vue"
export default component.exports